'use client';

import { runWhenPageReadyAndIdle } from '@/lib/ui/run-when-idle';
import { useEffect } from 'react';

const AURORA_READY_ATTR = 'data-aurora-ready';

export function AuroraTextRuntime() {
  useEffect(() => {
    return runWhenPageReadyAndIdle(() => {
      document.documentElement.setAttribute(AURORA_READY_ATTR, 'true');
    });
  }, []);

  return null;
}
